import { DateTime } from 'luxon'
import { useEmployee } from '@hooks/useEmployee'
import { useUserId } from './useUserId'
import { useHolidaysByCalendar } from '@hooks/useHolidays'

interface WeekRangeOptions {
  start: DateTime
  end: DateTime
}

export const useHolidays = ({ start, end }: WeekRangeOptions) => {
  const userId = useUserId()
  const employeeQuery = useEmployee({ userId, startDate: start })

  return useHolidaysByCalendar({
    holidayCalendarId: employeeQuery.data?.holidayCalendarId,
    start,
    end,
  })
}
